import React from 'react';
import PropTypes from 'prop-types';

class Loader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleLoader = this.toggleLoader.bind(this);

    this.state = {
      isLoaderShown: false
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.props.data.size === 0 && newProps.data.size !== 0) {
      if (newProps.loaderTimeout)
        this.timer = setTimeout(this.toggleLoader, 1000);
      else {
        this.toggleLoader();
      }
    }

    if (this.props.data.size !== 0 && newProps.data.size === 0) {
      clearTimeout(this.timer);
      if (this.state.isLoaderShown) this.toggleLoader();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  toggleLoader() {
    this.setState({ isLoaderShown: !this.state.isLoaderShown });
  }

  render() {
    const { data } = this.props;
    const display = this.state.isLoaderShown;
    let text = '';

    if (data.size === 1) {
      text = data.values().next().value;
    } else {
      data.forEach(value => {
        text += `${value}, `;
      });
    }

    text =
      text.slice(0, 1).toUpperCase() + text.slice(1, text.length).toLowerCase();
    text = text.replace(/(,\s$)|(,$)/g, '');

    return (
      <div className="loader" style={{ display: display ? 'flex' : 'none' }}>
        <i className="fa fa-spinner fa-pulse fa-4x"></i>
        <div className="loader-text">{text}</div>
      </div>
    );
  }
}

Loader.propTypes = {
  data: PropTypes.object
};

Loader.defaultProps = {
  data: new Map()
};

export default Loader;
